// extracted by mini-css-extract-plugin
export default {"container":"TechStack_container__OuUUk","iconContainer":"TechStack_iconContainer__Mn1C-","text":"TechStack_text__9Nu-h"};